import { DynamicStandaloneInstagram } from '@/components/Instagram';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorInstagram: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneInstagram
      postId={data?.postId}
      options={data.options}
      hidecaption={data.hidecaption}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorInstagram;
